export default "__VITE_ASSET__Clv70NqL__"